// extracted by mini-css-extract-plugin
export default {"configLink":"ActionProviderDocs_configLink__g2-u7"};